import 'lodash'
import '@babel/polyfill';
import '@mdi/font/css/materialdesignicons.css'
import 'gox'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/gx-ui';
import './lib/gox.css'
import './lib/gox_custom.css'
import vuetify from './plugins/vuetify';
import {initializeApp} from 'firebase'
import store from './store/store'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

document.title = `XMAP Assess ${process.env.VUE_APP__VERSION_NUMBER_}`;

const config = {
  apiKey: "AIzaSyAkj1b9R4d3MSghcuhS4qNnLAUlMBuqp-s",
  authDomain: "topographic-assessment.firebaseapp.com",
  databaseURL: "https://topographic-assessment.firebaseio.com",
  projectId: "topographic-assessment",
  storageBucket: "topographic-assessment.appspot.com",
  messagingSenderId: "940890978612"
};
initializeApp(config);


Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');
